// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"jut__ModalFooter__modalFooter","modalFooterFlexLayout":"jut__ModalFooter__modalFooterFlexLayout"};